(ns teamoesterreich.user-mode.prevent.prevent-questionnaire-summary
  (:require
    [clojure.string]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    [reagent-material-ui.icons.keyboard-arrow-right :refer [keyboard-arrow-right]]
    [reagent.core :as r]
    [teamoesterreich.store :as store]
    [teamoesterreich.user-mode.actions :as a]
    [teamoesterreich.user-mode.prevent.answer-option-ro :as ao]
    [teamoesterreich.util.log :as log]
    ))





(defn get-it []
  (fn []
    (let [q-stars 1
          selected-questionnaire-cs (r/cursor store/app-state [:state :selected-questionnaire])
          questionnaire-cs (r/cursor store/app-state [:questionnaires @selected-questionnaire-cs])
          questionnaire-response-cs (r/cursor store/app-state [:user-questionnaires @selected-questionnaire-cs])
          ]
      (log/debug "act-questionnaire " @selected-questionnaire-cs @questionnaire-cs)
      [mui/grid
       {:container  true
        :direction  "row"
        :justify    "center"
        :alignItems "stretch"
        :spacing    1
        }

       [mui/grid
        {:container false
         :item      true
         :xs        12
         }
        ""]
       [mui/grid
        {:container false
         :item      true
         :lg        7
         :xs        11
         }

        [mui/card {:class-name "wrap-content-card"}
         [mui/card-content
          [mui/typography {:variant "h4"} (:name @questionnaire-cs)]
          [:br]
          "Zusammenfassung"
          [:br]]

         (for [[questionId question] (get-in @questionnaire-cs [:questions])]
           ^{:key (str "question-" questionId)} [mui/card-content {:key (str "summary_question_" questionId)}
                                                 [mui/typography {:variant "h6"} (str (:question question))]
                                                 ;(log/debug (r/cursor questionnaire-response-cs [:questions questionId]))
                                                 [ao/answer-options (r/cursor questionnaire-cs [:questions questionId]) (r/cursor questionnaire-response-cs [:questions questionId])]
                                                 ])


         [mui/card-actions
          [mui/grid
           {:container  true
            :direction  "row"
            :justify    "center"
            :alignItems "stretch"
            :spacing    1
            }

           [mui/grid
            {:container false
             :item      true
             :md        6
             :xs        12
             }
            [mui/button
             {:variant   "contained"
              :color     "default"
              :edge      "start"
              :class     "bottom-button"
              :onClick   #(a/set-page-back)
              :startIcon (r/as-element [keyboard-arrow-left])
              }
             "Zurück"]]
           [mui/grid
            {:container false
             :item      true
             :md        6
             :xs        12
             }

            [mui/button
             {:variant   "contained"
              :edge      "end"
              :color     "primary"
              :class     "bottom-button"
              :onClick   #(a/set-page :prevent-overview :landing)
              :startIcon (r/as-element [keyboard-arrow-right])
              }
             "Fertig"]]]
          ]

         ]]

       ]
      )))

